export default __webpack_public_path__ + "static/logo-orange-c13980a039f9b8db5e09ab19c77fcf5e.webp";